import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import { withTranslation } from 'react-i18next';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import Button from 'components/UI/CustomButtons/Button';
import Muted from 'components/UI/Typography/Muted';
import CardFooter from 'components/UI/Card/CardFooter';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
// material-ui icons
import Clock from '@material-ui/icons/QueryBuilder';
import Refresh from '@material-ui/icons/Refresh';
import Edit from '@material-ui/icons/Edit';
// styles
import DashboardStyles from 'assets/jss/material-dashboard-pro-react/views/dashboardStyle';
import moment from 'moment';

const metricsRange = [
  { title: 'date.last_week', value: 'last_week' },
  { title: 'date.last_month', value: 'last_month' },
];

class MetricsFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      range: metricsRange[0],
    };
  }

  /**
   * @description
   * Called when user tap the Date range button.
   * @param {string} range - Selected value.
   */
  updateData = range => {
    const { onUpdate } = this.props;
    this.setState({ range });
    onUpdate(range.value);
  };

  render() {
    const { classes, t } = this.props;
    const { range } = this.state;
    const updatedOn = moment();
    return (
      <CardFooter stats>
        <Muted>
          <Clock />
          Actualizado{' '}
          <Moment fromNow ago>
            {updatedOn}
          </Moment>
        </Muted>
        <div className={classes.rightActions}>
          <FormControl className={classes.selectFormControl}>
            <Select
              autoWidth
              classes={{
                select: classes.select,
                icon: classes.selectIcon,
                root: classes.selectRoot,
              }}
              renderValue={value => (
                <div>
                  <Edit />
                  {value}
                </div>
              )}
              value={t(range.title)}
              onChange={event => {
                this.updateData(event.target.value);
              }}
              inputProps={{
                id: 'selectRangeStats',
              }}
            >
              {metricsRange.map(item => (
                <MenuItem
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected,
                  }}
                  value={item}
                  key={item.value}
                >
                  {t(item.title)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            className={classes.actionBtns}
            justIcon
            simple
            color="primary"
            onClick={() => this.updateData(range)}
          >
            <Refresh />
          </Button>
        </div>
      </CardFooter>
    );
  }
}

MetricsFooter.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  onUpdate: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(withStyles(DashboardStyles)(MetricsFooter));
